/*
  Şehir seçimini aramalı listeye çevirir (sepet çekmecesi + sepet sayfası).
  Asıl <select> DOM'da kalır ve tek doğruluk kaynağıdır: seçim yapılınca select.value
  değişir ve 'change' olayı atılır; mevcut sepet kodları (cart attributes, localStorage,
  ödeme engeli) hiç değişmeden çalışır.
  Kullanım: window.stadtSuche(selectElementi)
*/
(function () {
  if (window.stadtSuche) return;

  function norm(s) {
    return (s || '')
      .toLocaleLowerCase('de')
      .replace(/ß/g, 'ss')
      .replace(/ı/g, 'i')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  }

  var stilEklendi = false;
  function stilEkle() {
    if (stilEklendi) return;
    stilEklendi = true;
    var st = document.createElement('style');
    st.textContent =
      '.stadt-suche{position:relative}' +
      '.stadt-suche__native{position:absolute!important;width:1px!important;height:1px!important;opacity:0!important;pointer-events:none!important;overflow:hidden!important;clip:rect(0 0 0 0)!important}' +
      '.stadt-suche__input{width:100%;cursor:text;box-sizing:border-box}' +
      '.stadt-suche__list{list-style:none;margin:6px 0 0;padding:4px;max-height:240px;overflow-y:auto;border:1.5px solid rgba(0,0,0,.12);border-radius:8px;background:#fff;box-shadow:0 8px 24px rgba(0,0,0,.08)}' +
      '.stadt-suche__list[hidden]{display:none}' +
      '.stadt-suche__opt{padding:9px 10px;border-radius:6px;cursor:pointer;font-size:.9rem;line-height:1.3}' +
      '.stadt-suche__opt.is-active,.stadt-suche__opt:hover{background:rgba(0,0,0,.06)}' +
      '.stadt-suche__opt.is-selected{font-weight:700}' +
      '.stadt-suche__opt--other{border-top:1px solid rgba(0,0,0,.08);margin-top:4px;font-style:italic}' +
      '.stadt-suche__empty{padding:9px 10px;font-size:.85rem;opacity:.65}';
    document.head.appendChild(st);
  }


  /* ── 250 sınırını aşan şehirleri yükleme ──
     Sepetteki <select> sunucudan en çok 250 teslim noktasıyla gelir. Kalanlar
     sections/stadt-liste'den (JSON) sayfa sayfa çekilir ve listeye eklenir. */
  var listeSozu = null;
  function tamListe() {
    if (listeSozu) return listeSozu;
    var kok = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var anahtar = 'stadt_liste_v1:' + kok;
    try {
      var k = JSON.parse(sessionStorage.getItem(anahtar) || 'null');
      if (k && Date.now() - k.t < 30 * 60 * 1000) { listeSozu = Promise.resolve(k.liste); return listeSozu; }
    } catch (e) {}
    function sayfa(param, n) {
      var url = kok + '?section_id=stadt-liste' + (param ? '&' + encodeURIComponent(param) + '=' + n : '');
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var m = html.match(/<script type="application\/json" data-stadt-liste>([\s\S]*?)<\/script>/);
        return JSON.parse(m[1]);
      });
    }
    listeSozu = sayfa(null, 1).then(function (ilk) {
      var istekler = [];
      for (var n = 2; n <= ilk.sayfalar; n++) istekler.push(sayfa(ilk.param, n));
      return Promise.all(istekler).then(function (digerleri) {
        var liste = [];
        [ilk].concat(digerleri).forEach(function (d) { d.liste.forEach(function (x) { if (x) liste.push(x); }); });
        try { sessionStorage.setItem(anahtar, JSON.stringify({ t: Date.now(), liste: liste })); } catch (e) {}
        return liste;
      });
    }).catch(function () { listeSozu = null; return []; });
    return listeSozu;
  }

  function eksikleriEkle(select, liste) {
    var var_ = {};
    for (var i = 0; i < select.options.length; i++) var_[select.options[i].value] = true;
    var eklendi = 0;
    liste.forEach(function (x) {
      var v = (x.sehir || '').toLowerCase();
      if (!v || var_[v]) return;
      var o = document.createElement('option');
      o.value = v;
      o.textContent = x.sehir;
      o.setAttribute('data-location', x.bolge || '');
      o.setAttribute('data-address', x.adres || '');
      o.setAttribute('data-date', x.tarih || '');
      o.setAttribute('data-hours', x.saat || '');
      o.setAttribute('data-note', x.not || '');
      select.appendChild(o);
      var_[v] = true;
      eklendi++;
      // Sepet sayfasındaki bilgi kutusu (global.js) şehri [data-pickup-city] öğelerinden okur
      if (!document.querySelector('[data-pickup-city="' + x.sehir.replace(/"/g, '\\"') + '"]')) {
        var d = document.createElement('div');
        d.className = 'visually-hidden';
        d.hidden = true;
        d.setAttribute('data-pickup-city', x.sehir);
        d.setAttribute('data-active', 'true');
        d.setAttribute('data-location', x.bolge || '');
        d.setAttribute('data-address', x.adres || '');
        d.setAttribute('data-date', x.tarih || '');
        d.setAttribute('data-hours', x.saat || '');
        d.setAttribute('data-note', x.not || '');
        document.body.appendChild(d);
      }
    });
    if (!eklendi) return;
    // Şehirleri yeniden alfabetik diz (boş seçenek ve "Andere Stadt" başta kalır)
    var sehirler = [];
    for (var j = select.options.length - 1; j >= 0; j--) {
      var op = select.options[j];
      if (op.value && op.getAttribute('data-is-other') !== 'true') sehirler.push(op);
    }
    var secili = select.value;
    sehirler.sort(function (a, b) { return a.textContent.localeCompare(b.textContent, 'de'); });
    sehirler.forEach(function (op) { select.appendChild(op); });
    select.value = secili;
    // Daha önce seçilmiş ama ilk 250'de olmayan şehir artık geri yüklenebilir
    try {
      var kayitli = localStorage.getItem('lezzetci_city');
      if (!select.value && kayitli && var_[kayitli]) {
        select.value = kayitli;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } catch (e) {}
  }

  var sayac = 0;

  function stadtSuche(select) {
    if (!select || select.getAttribute('data-stadt-suche') === '1') return;
    select.setAttribute('data-stadt-suche', '1');
    stilEkle();
    sayac += 1;

    var ph = select.getAttribute('data-search-placeholder') || 'Stadt suchen …';
    var bos = select.getAttribute('data-search-empty') || 'Keine Stadt gefunden';
    var listeId = 'stadt-suche-liste-' + sayac;

    var kap = document.createElement('div');
    kap.className = 'stadt-suche';
    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'stadt-suche__input ' + select.className;
    input.placeholder = ph;
    input.autocomplete = 'off';
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', listeId);
    if (select.id) {
      var etiket = document.querySelector('label[for="' + select.id + '"]');
      input.id = select.id + '-suche';
      if (etiket) etiket.setAttribute('for', input.id);
    }
    var liste = document.createElement('ul');
    liste.className = 'stadt-suche__list';
    liste.id = listeId;
    liste.setAttribute('role', 'listbox');
    liste.hidden = true;

    select.parentNode.insertBefore(kap, select);
    kap.appendChild(input);
    kap.appendChild(liste);
    kap.appendChild(select);
    select.classList.add('stadt-suche__native');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    var aktif = -1;
    var gorunen = [];

    function secilenMetin() {
      var o = select.options[select.selectedIndex];
      return o && o.value ? o.textContent.trim() : '';
    }

    function ciz() {
      var q = norm(input.value === secilenMetin() ? '' : input.value);
      liste.innerHTML = '';
      gorunen = [];
      var diger = null;
      for (var i = 0; i < select.options.length; i++) {
        var o = select.options[i];
        if (!o.value) continue;
        if (o.getAttribute('data-is-other') === 'true') { diger = o; continue; }
        if (!q || norm(o.textContent).indexOf(q) !== -1) gorunen.push(o);
      }
      // Başı eşleşenler önce ("Bo" → Bochum, Bonn … sonra Hamborn)
      if (q) {
        gorunen.sort(function (a, b) {
          var ab = norm(a.textContent).indexOf(q) === 0 ? 0 : 1;
          var bb = norm(b.textContent).indexOf(q) === 0 ? 0 : 1;
          return ab - bb;
        });
      }
      if (!gorunen.length) {
        var e = document.createElement('li');
        e.className = 'stadt-suche__empty';
        e.textContent = bos;
        liste.appendChild(e);
      }
      if (diger) gorunen.push(diger);
      gorunen.forEach(function (o, n) {
        var li = document.createElement('li');
        li.className = 'stadt-suche__opt' + (o === diger ? ' stadt-suche__opt--other' : '') + (o.selected ? ' is-selected' : '');
        li.setAttribute('role', 'option');
        li.id = listeId + '-' + n;
        li.textContent = o.textContent.trim();
        li.addEventListener('mousedown', function (ev) { ev.preventDefault(); sec(o); });
        liste.appendChild(li);
      });
      aktif = q && gorunen.length ? 0 : -1;
      isaretle();
    }

    function isaretle() {
      var lis = liste.querySelectorAll('.stadt-suche__opt');
      for (var i = 0; i < lis.length; i++) lis[i].classList.toggle('is-active', i === aktif);
      if (aktif >= 0 && lis[aktif]) {
        input.setAttribute('aria-activedescendant', lis[aktif].id);
        var li = lis[aktif];
        if (li.offsetTop < liste.scrollTop) liste.scrollTop = li.offsetTop;
        else if (li.offsetTop + li.offsetHeight > liste.scrollTop + liste.clientHeight) liste.scrollTop = li.offsetTop + li.offsetHeight - liste.clientHeight;
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function ac() { ciz(); liste.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function kapat() { liste.hidden = true; input.setAttribute('aria-expanded', 'false'); aktif = -1; }

    function sec(o) {
      if (select.value !== o.value) {
        select.value = o.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      input.value = o.textContent.trim();
      kapat();
      input.blur();
    }

    input.addEventListener('focus', function () { input.select(); ac(); });
    input.addEventListener('click', function () { if (liste.hidden) ac(); });
    input.addEventListener('input', function () { ac(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (liste.hidden) ac(); aktif = Math.min(aktif + 1, gorunen.length - 1); isaretle(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); aktif = Math.max(aktif - 1, 0); isaretle(); }
      else if (e.key === 'Enter') {
        if (!liste.hidden && gorunen.length) { e.preventDefault(); sec(gorunen[aktif >= 0 ? aktif : 0]); }
      }
      else if (e.key === 'Escape') { input.value = secilenMetin(); kapat(); }
    });
    input.addEventListener('blur', function () {
      setTimeout(function () { kapat(); input.value = secilenMetin(); }, 120);
    });

    // Dış kod select'i değiştirir ya da odaklarsa (ödeme uyarısı) arama kutusu takip eder
    select.addEventListener('change', function () { input.value = secilenMetin(); });
    select.addEventListener('focus', function () { input.focus(); });

    input.value = secilenMetin();

    tamListe().then(function (veri) {
      if (!select.isConnected) return;
      eksikleriEkle(select, veri);
      if (document.activeElement !== input) input.value = secilenMetin();
      else if (!liste.hidden) ciz();
    });
  }

  window.stadtSuche = stadtSuche;
  window.stadtListesi = tamListe; // Lieferadressen sayfası da kullanır
})();
